package de.connect2x.timmy.brandings.aokTheme
import androidx.compose.ui.graphics.Color

/* AOK Primaerfarben*/
internal val aok_primary_dark_green = Color(0xFF005E3F)
internal val aok_primary_light_green = Color(0xFF50EB5D)
internal val aok_primary_light_white = Color(0xFfFFFFFF)

/*AOK Akzentfarben*/
internal val aok_accent_yellow = Color(0xFFFFF133)
internal val aok_accent_blue = Color(0xFF83EAF2)
internal val aok_accent_interactive_green = Color(0xFf91F54A)

/*AOK Strukturierungsfarben*/
internal val aok_structure_pastel_blue = Color(0xFFE8F4F2)
internal val aok_structure_pastel_green = Color(0xFFEEFAEA)
internal val aok_structure_sand = Color(0xFfF8F5E3)
internal val aok_structure_deep_green = Color(0xFF004730)

/*AOK Gruenstufen*/
internal val aok_green_8 = Color(0xFF005E3F)
internal val aok_green_7  = Color(0xFF007141)
internal val aok_green_6  = Color(0xFF028440)
internal val aok_green_5  = Color(0xFF07983E)
internal val aok_green_4  = Color(0xFF18AB42)
internal val aok_green_3  = Color(0xFF35BF50)
internal val aok_green_2  = Color(0xFF60D26D)
internal val aok_green_1  = Color(0xFF98E692)

/*AOK Graustufen*/
internal val aok_grey_8 = Color(0xFF40484D)
internal val aok_grey_7  = Color(0xFF586167)
internal val aok_grey_6  = Color(0xFF6D767C)
internal val aok_grey_5  = Color(0xFF828B91)
internal val aok_grey_4  = Color(0xFF98A1A6)
internal val aok_grey_3  = Color(0xFFAFB6BC)
internal val aok_grey_2  = Color(0xFFC7CCD1)
internal val aok_grey_1  = Color(0xFFDFE3E6)

/*Einige AOK Hilfsfarben*/
//Error
internal val aok_has_error  = Color(0xFFEB0047)
internal val aok_error_dark = Color(0xFFC40D38)
internal val aok_error_light  = Color(0xFFFA545E)


